
import * as ipxRuntime$_8x8gDlNre9PAWhJhkfT4ERT_oMwjwhME98agpyFKpNA from '/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_8x8gDlNre9PAWhJhkfT4ERT_oMwjwhME98agpyFKpNA, defaults: {} }
}
        